import { Link } from "react-router-dom";
import PropTypes from 'prop-types';


export default function LinkParams({ className = '', to = '', params = {}, children }) {
  // Separar pathname y search si 'to' incluye '?'
  let pathname = to;
  let baseSearch = '';
  if (typeof to === 'string' && to.includes('?')) {
    const [path, search] = to.split('?');
    pathname = path;
    baseSearch = search;
  }

  // Tomar los search params actuales de la URL
  const currentParams = new URLSearchParams(window.location.search);

  // Si 'to' traía search, añadirlos también
  if (baseSearch) {
    const baseParams = new URLSearchParams(baseSearch);
    for (const [key, value] of baseParams.entries()) {
      currentParams.set(key, value);
    }
  }

  // Añadir/actualizar los params extra
  for (const key in params) {
    if (params[key] !== undefined && params[key] !== null) {
      currentParams.set(key, params[key]);
    }
  }

  const searchString = currentParams.toString();

  // Nunca pasar '?' en pathname
  return (
    <Link
      to={{
        pathname,
        search: searchString ? `?${searchString}` : ''
      }}
      className={className}
    >
      {children}
    </Link>
  );
}

LinkParams.propTypes = {
  className: PropTypes.string,
  to: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
  params: PropTypes.object
};